import { DataType, IData } from '@tencent/slide-sdk-model';
import { Reporter007 } from '../../../infrastructure/module/dependent/report/real-time-report/constant';
import { statusReport007 } from '../../../infrastructure/module/dependent/report/real-time-report/real-time';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import type { ISdkDataValidate } from '@tencent/slide-sdk-validate';

interface IValidateReportInfo {
    isPass: boolean;
    errors: ReturnType<ISdkDataValidate['validateModelData']>['errors'];
    dataType: DataType | undefined;
    cost: number;
    source:
        | 'paste_inherited'
        | 'paste_owned'
        | 'import_pagination'
        | 'ai_add_page'
        | 'change_template_add_master'
        | 'iSlide_import';
}

export function dataValidateAndReport<T extends IData>(
    data: T,
    source: IValidateReportInfo['source'],
    dataType: DataType | undefined,
) {
    const validator = SlideDataServices.SDKDataServices.DataValidator();
    const { isPass, errors, cost = -1 } = validator?.validateModelData(data) ?? {};
    validateDataReport({
        isPass: !!isPass,
        errors,
        dataType,
        cost,
        source,
    });
}

export function validateDataReport({ isPass, errors, dataType, cost, source }: IValidateReportInfo) {
    try {
        const errorCount = errors?.length ?? 0;
        const firstError = errors?.[0] ?? { keyword: '' };
        if (!isPass) {
            // 若不通过，只上报前三个错误
            statusReport007(
                'validate_error',
                Reporter007.ERROR,
                JSON.stringify(errors?.slice(0, 3)),
                [
                    dataType ? DataType[dataType] : '',
                    firstError.keyword,
                    '', // 这个字段放不了内容，不清楚原因
                    source,
                    JSON.stringify({ cost: cost.toFixed(2), errorCount }),
                ],
            );
        } else {
            statusReport007('validate_error', Reporter007.SUCCESS, '', [
                dataType ? DataType[dataType] : '',
                '',
                '',
                source,
                JSON.stringify({ cost: cost.toFixed(2) }),
            ]);
        }
    } catch (e) {
        console.error(e);
    }
}
